<pw-view-title>{{ 'planning.board.title' | translate }}</pw-view-title>

<pw-view-actions class="view-actions">
  <div class="view-actions">
    <button mat-icon-button (click)="toggleDrawer()">
      <mat-icon>filter_list</mat-icon>
    </button>
    <button mat-icon-button routerLink="partscan">
      <mat-icon>barcode_reader</mat-icon>
    </button>
  </div>
</pw-view-actions>

<pw-view-drawer>
  <div class="view-drawer">
    <mat-form-field>
      <input
        placeholder="{{ 'planning.board.filterStart' | translate }}"
        matInput
        [min]="filterStartRange"
        [max]="filterEndRange"
        [matDatepicker]="pickerStart"
        [(ngModel)]="filterStart" />
      <mat-datepicker-toggle
        matSuffix
        [for]="pickerStart"></mat-datepicker-toggle>
      <mat-datepicker #pickerStart></mat-datepicker>
    </mat-form-field>

    <mat-form-field>
      <input
        placeholder="{{ 'planning.board.filterEnd' | translate }}"
        matInput
        [matDatepicker]="pickerEnd"
        [(ngModel)]="filterEnd" />
      <mat-datepicker-toggle
        matSuffix
        [for]="pickerEnd"></mat-datepicker-toggle>
      <mat-datepicker #pickerEnd></mat-datepicker>
    </mat-form-field>

    <mat-form-field style="grid-column: span 2">
      <mat-label>{{ 'planning.board.filterForerun' | translate }}</mat-label>
      <input matInput [(ngModel)]="filterLead" />
    </mat-form-field>

    <mat-slide-toggle [(ngModel)]="filterFinished"
      >{{ 'planning.board.filterIncludeFinished' | translate }}
    </mat-slide-toggle>

    <mat-form-field>
      <mat-label>{{
        'planning.board.filterOnlyApproved' | translate
      }}</mat-label>
      <input matInput [(ngModel)]="filterOnlyReleased" type="number" />
    </mat-form-field>

    <div
      style="
        grid-column: auto / span 2;
        justify-content: end;
        display: flex;
        padding: 1rem;
      ">
      <button mat-button color="primary" (click)="cancel()">
        {{ 'planning.board.discard' | translate }}
      </button>
      <button
        mat-raised-button
        color="accent"
        (click)="setFilter(); cvs.drawer.toggle()"
        style="grid-column: span 2">
        {{ 'planning.board.filterApply' | translate }}
      </button>
    </div>
  </div>
</pw-view-drawer>

<div [ngClass]="isMobile ? 'flex-column' : 'flex-row'">
  <mat-form-field>
    <input
      type="text"
      matInput
      placeholder="Filter"
      [formControl]="searchFormControl" />
  </mat-form-field>
  <mat-chip-listbox *ngIf="filterChips" style="align-self: center">
    <mat-chip *ngFor="let chip of filterChips">
      {{ chip.name }}: {{ chip.value }}
      <button
        *ngIf="!chip.required"
        matChipRemove
        (click)="removeChip(chip.name)">
        <mat-icon>cancel</mat-icon>
      </button>
    </mat-chip>
  </mat-chip-listbox>
</div>

<div *checkPermission="[{ name: 'P4_SHOW_MY_PROLEIS_TASKS' }]">
  <ng-container *ngIf="ppsService.resources$ | async as resources">
    <mat-tab-group
      *ngIf="resources.length > 0 && !isMobile; else noResources"
      (selectedTabChange)="onTabChanged($event)"
      animationDuration="0ms"
      [selectedIndex]="getSelectedTab(resources)">
      <mat-tab
        *ngFor="let res of ppsService.resources$ | async"
        [label]="res.NAME">
        <ng-template matTabContent>
          <div [ngClass]="isMobile ? 'mobile' : ''">
            <div class="board-container">
              <p4m-pps-lane
                laneTitle="{{ 'planning.board.todo' | translate }}"
                (filterEvent)="toggleDrawer()"
                [tasks]="ppsService.todoTasks$"></p4m-pps-lane>
              <p4m-pps-lane
                laneTitle="{{ 'planning.board.inProgress' | translate }}"
                (filterEvent)="toggleDrawer()"
                [tasks]="ppsService.inProgressTasks$"></p4m-pps-lane>
              <p4m-pps-lane
                laneTitle="{{ 'planning.board.finished' | translate }}"
                (filterEvent)="toggleDrawer()"
                [tasks]="ppsService.finishedTasks$"></p4m-pps-lane>
            </div>
          </div>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </ng-container>
</div>

<div *ngIf="isMobile">
  <mat-form-field style="width: 100%">
    <mat-label>{{ 'planning.board.resources' | translate }}</mat-label>
    <mat-select
      (selectionChange)="onResourceChanged($event)"
      [value]="ppsService.selectedResource$ | async">
      <mat-option
        *ngFor="let res of ppsService.resources$ | async"
        [value]="res"
        >{{ res.TEXT }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <div class="mat-elevation-z6" *ngIf="user$ | async as user">
    <div
      class="mat-elevation-z6"
      *ngFor="let task of (ppsService.ppsResource$ | async)?.tasks">
      <p4m-mobile-task-component
        [task]="task"
        [user]="user"
        (onStartTracking)="ppsService.onStartTracking($event)"
        (onStopTracking)="
          ppsService.onStopTracking($event)
        "></p4m-mobile-task-component>
      <mat-divider vertical="false"></mat-divider>
    </div>
  </div>
</div>

<ng-template #noResources>
  <div *ngIf="!isMobile">
    {{ 'planning.board.noResourcesFound' | translate }}
  </div>
</ng-template>
